import React from 'react';
import * as moment from 'moment';
import * as Modal from 'react-modal';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import FlatPagination from 'material-ui-flat-pagination';
import { Auth } from 'aws-amplify';
import loader from '../../images/Spin-1s-107px.gif';
import BannerHead from '../BannerHead';
import NotificationTemplate from './NotificationTemplate'
import { Checkbox } from '@material-ui/core';
import { connect } from 'react-redux';
import { ToastContainer, toast } from "react-toastify";

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    overflow: 'hidden',
    width: '635px',
  },
};

const customStylesNotification = {
  content: {
    top: '10%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    border: '1px solid rgb(204, 204, 204)',
    borderRadius: '4px',
    marginRight: '-50%',
    transform: 'translate(-50%, 0%)',
    overflow: 'hidden',
    width: '60%',
    maxHeight: '80vh',
    position: 'absolute',
    padding: '20px',
    background: '#fff',
  },
};

class Notifications extends React.Component {
  state = {
    confirmModal: false,
    notificationModal: false,
    notificationLogId: null,
    offset: 0,
    isLoading: false,
    intervalId: 0,
    userId: localStorage.getItem('userId'),
    recievedNotifications: [],
    allChecked: false,
    deleteAllNotificationsModal: false,
    markAllStatus: false,
    viewPopupId: "",
  };

  /**
   * Load All Notifications
   */
  componentDidMount() {
    const { userId } = this.state;
    let ids = []

    const data = {
      userId,
      pageNumber: 0,
      pageSize: 10,
      searchKeyword: '',
    };
    this.props.getAllNotifications(data);
    this.props.markNotificationReadForUser({ userId,ids });
  }

  componentWillReceiveProps(newProps) {
    if(newProps.data.recievedNotifications.records && newProps.data.recievedNotifications.records.length == 0 && newProps.data.recievedNotifications.pageNumber != 0) {
      const {userId, offset} = this.state;
      const pageNumber = offset / 10;
      const data = {
        userId,
        pageNumber: pageNumber-1,
        pageSize: 10,
        searchKeyword: '',
      };
      this.props.getAllNotifications(data);
      this.setState({offset: (pageNumber-1)*10});
    } else if (newProps.data.recievedNotifications.records && newProps.data.recievedNotifications.records.length == 0 && newProps.data.recievedNotifications.pageNumber == 0 && (newProps.data.recievedNotifications.pageNumber != this.props.data.recievedNotifications.pageNumber)) {
       
      const {userId, offset} = this.state;
      const pageNumber = offset / 10;
      const data = {
        userId,
        pageNumber,
        pageSize: 10,
        searchKeyword: '',
      };
      this.props.getAllNotifications(data);
      this.setState({offset: pageNumber*10});
    }
    if(newProps.data.recievedNotifications && newProps.data.recievedNotifications.records) {
      let notificationArray = newProps.data.recievedNotifications.records.filter(recievedNoti => recievedNoti.readStatus == "N")
      if(notificationArray.length == 0) {
        this.setState({
          markAllStatus: true
        })
      }else {
        this.setState({
          markAllStatus: false
        })
      }
      
    }
    if(newProps.markNotificationSuccess && newProps.markNotificationSuccess.code == '302' && this.state.isLoading == true) {
      this.setState({
        isLoading: false,
        allChecked: false
      })
      const {userId, offset} = this.state;
      const pageNumber = offset / 10;
      const data = {
        userId,
        pageNumber,
        pageSize: 10,
        searchKeyword: '',
      };
      this.props.getAllNotifications(data);
    }
    if(newProps.data.deleteNotification && newProps.data.deleteNotification.code == '302' && this.state.isLoading == true) {
      this.setState({
        isLoading: false,
        deleteAllNotificationsModal: false,
        allChecked: false
      })
      const {userId, offset} = this.state;
      const pageNumber = offset / 10;
      const data = {
        userId,
        pageNumber,
        pageSize: 10,
        searchKeyword: '',
      };
      this.props.getAllNotifications(data);
    }
    if(newProps.data.recievedNotifications && newProps.data.recievedNotifications.records){
      let checkedRecievedNotifications = newProps.data.recievedNotifications.records

          checkedRecievedNotifications = checkedRecievedNotifications.map(notification => {
            var notify = Object.assign({}, notification);
            notify.isChecked = false
            return notify
          })

          this.setState({
            recievedNotifications: checkedRecievedNotifications
          })
    }
          
  }

  /**
   * Scroll to top off the page
   */
  componentWillMount() {
    if (localStorage.getItem('paymentStatus') === 'pending'
        && !!localStorage.getItem('paymentFailedButLetUserIn') === false) {
      this.props.history.push('/add-payment-method');
    }
    // if (localStorage.getItem('paymentStatus') === 'pending') {
    //   localStorage.clear();
    //   Auth.signOut().then(async () => {
    //     await this.props.logoutUser();
    //     this.props.clearDataEmail();
    //     this.context.router.history.push('/');
    //   }).catch(error => error);
    // }

    const intervalId = setInterval(this.scrollStep.bind(this), this.props.delayInMs);
    this.setState({
      intervalId,
    });
  }

  scrollStep=() => {
    if (window.pageYOffset === 0) {
      clearInterval(this.state.intervalId);
    }
    window.scroll(0, window.pageYOffset - this.props.scrollStepInPx);
  }

  componentDidUpdate() {
    const { notificationMarkCount } = this.props.data;
    const { notificationMarkCountD, userId } = this.state;
    if (notificationMarkCount !== notificationMarkCountD) {
      this.props.getNotificationLogUnReadCountForUser({ userId });
      this.setState({
        notificationMarkCountD: notificationMarkCount,
      });
    }
  }

    /**
   * Delete All Notification Confirm Modal
   */
  deleteAllConfirmNotificationModal = () => {
    this.setState({
      deleteAllNotificationsModal: true
    })
  };

  /**
   * Mark All Read Confirm Modal
   */
  markAllReadConfirmModal = async() => {
    this.setState({
      isLoading: true
    })
    const {userId} = this.state;

    let recievedNotificationsArray = this.state.recievedNotifications
    let idsToBeMarked = recievedNotificationsArray.map(notificationId => notificationId.id);
    
    const dataToMark = {
      userId,
      ids:idsToBeMarked
    };
    await this.props.markAllReadNotification(dataToMark);
  };


  closeAllNotificationModal  = () => {
    this.setState({
      deleteAllNotificationsModal: false
    })
  }


    /**
   * Delete All Notification
   */

  deleteAllconfirmNotification = async () => {
    this.setState({
      isLoading: true
    })
    const {userId, offset} = this.state;

    let recievedNotificationsArray = this.state.recievedNotifications
    let idsToBeDeleted = recievedNotificationsArray.map(notificationId => notificationId.id);
    
    const dataToDelete = {
      userId,
      ids:idsToBeDeleted,
      pageSize: 10,
      searchKeyword: '',
    };
    await this.props.removeNotification(dataToDelete);
    const pageNumber = offset / 10;
    const data = {
      userId,
      pageNumber,
      pageSize: 10,
      searchKeyword: '',
    };

  }
  /**
   * Delete Notification Confirm Modal
   */
  deleteconfirmNotification = (e, notificationLogId) => {
    let notificationLogIdArray = [notificationLogId]
    e.preventDefault();
    this.toggleConfirmModal();
    this.setState(() => ({ notificationLogId:notificationLogIdArray }));
  };

  viewNotification = async (e) => {
    const {userId, offset} = this.state;
    let recievedNotificationsArray = this.state.recievedNotifications
    let popupId = recievedNotificationsArray.filter(notificationId => notificationId.id == e.target.id);
    this.setState({
      notificationModal: true,
      viewPopupId: popupId[0].id,
      allChecked: false
      
    })
    const dataToMark = {
      userId,
      ids:[popupId[0].id],
    };
    await this.props.markAllReadNotification(dataToMark);
     const pageNumber = offset / 10;
     const data = {
       userId,
       pageNumber,
       pageSize: 10,
       searchKeyword: '',
     };
     this.props.getAllNotifications(data);
  }

  /**
   * Delete Notification
   */
  deleteNotification = async () => {
    this.setState({
      isLoading: true
    })
    const { notificationLogId, offset, userId } = this.state;
    const dataToDelete = {
      userId,
      ids:notificationLogId,
      pageSize: 10,
      searchKeyword: '',
    };
    await this.props.removeNotification(dataToDelete);
    this.toggleConfirmModal();
    const pageNumber = offset / 10;
    const data = {
      userId,
      pageNumber,
      pageSize: 10,
      searchKeyword: '',
    };
  };

  /**
   * Toggle Modal
   */
  toggleConfirmModal = () =>
    this.setState(state => ({ confirmModal: !state.confirmModal }));

  closeNotificationModal  = () => {
    this.setState({
      notificationModal: false
    })
    const {userId, offset} = this.state;
    const pageNumber = offset / 10;
    const data = {
      userId,
      pageNumber,
      pageSize: 10,
      searchKeyword: '',
    };
    this.props.getAllNotifications(data);
  }

  CheckboxClick = (e) => {
    let notificationArray = this.state.recievedNotifications
    let recievedNotifications
    if(this.state.allChecked == true && e.target.value == "1234"){
      this.setState({
        allChecked:false
      })
    }
    if(this.state.allChecked == false && e.target.value == "1234"){
      this.setState({
        allChecked:true
      })
    }
    if(e.target.value != "1234") {
      this.setState({
        allChecked: false
      })
      recievedNotifications = notificationArray.map(elem => elem.id == e.target.value ? {...elem, isChecked: e.target.checked} :elem)
    }else if (e.target.value == "1234"){
      let isValue = !this.state.allChecked;
      recievedNotifications = notificationArray.map(elem => {
       var notify = Object.assign({}, elem);
       notify.isChecked = isValue
       return notify
       })
    }
    this.setState({
      recievedNotifications
    }, () => {
      let checkedIds = recievedNotifications.filter(notiChecked => notiChecked.isChecked)
      if(checkedIds.length == 10) {
        this.setState({
          allChecked: true
        })
      }
    })
    
  }

  /**
   * Paginate Notifications
   */
  getNotifications = async (offset) => {
    const { userId } = this.state;
    const pageNumber = offset / 10;
    this.setState({ offset, isLoading: true,allChecked: false });
    await this.props.getAllNotifications({
      userId,
      pageNumber,
      pageSize: 10,
      searchKeyword: '',
    });
    this.setState({ offset, isLoading: false });
  };

  closeNotificationCross = () => {
    this.setState({
      notificationModal: false
    })
      const {userId, offset} = this.state;
      const pageNumber = offset / 10;
      const data = {
        userId,
        pageNumber,
        pageSize: 10,
        searchKeyword: '',
      };
      this.props.getAllNotifications(data);
  }

  render() {
    const { recievedNotifications } = this.props.data;
    const { confirmModal, isLoading } = this.state;
    return (
      <div className="container">
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
        {isLoading && (
          <div className="loader">
            <img src={loader} alt="" />
          </div>
        )}
        <Modal
          shouldCloseOnOverlayClick={false}
          isOpen={confirmModal}
          onRequestClose={this.toggleConfirmModal}
          style={customStyles}
          ariaHideApp={false}
        >
          <div className="modal-content addvehicle-content ">
            <div className="col s12 m7">
              <h4>Notification</h4>
            </div>
            <div className="col s12">
              <div className="grey-box">
                <div className="grey-inner">
                  <p> Are you sure want to delete this notification ? </p>
                  <button
                    onClick={this.deleteNotification}
                    className="btn waves-effect waves-light primary-btn col s12 m6 offset-m3 update-profile"
                    type="submit"
                    name="action"
                  >
                    Yes
                    <i className="material-icons">arrow_forward</i>
                  </button>

                  <button
                    onClick={this.toggleConfirmModal}
                    style={{ marginLeft: '5px' }}
                    className="btn waves-effect waves-light primary-btn col s12 m6 offset-m3 update-profile"
                    type="submit"
                    name="action"
                  >
                    No
                    <i className="material-icons">arrow_forward</i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Modal>
        <Modal
          isOpen={this.state.deleteAllNotificationsModal}
          onRequestClose={this.closeAllNotificationModal}
          style={customStyles}
          ariaHideApp={false}
        >
          <div className="modal-content addvehicle-content">
            <div className="col s12 m7">
              <h4>Notification</h4>
            </div>
            <div className="col s12">
              <div className="grey-box">
                <div className="grey-inner">
                  <p> Are you sure want to delete all the notifications ? </p>
                  <button
                    onClick={this.deleteAllconfirmNotification}
                    className="btn waves-effect waves-light primary-btn col s12 m6 offset-m3 update-profile"
                    type="submit"
                    name="action"
                  >
                    Yes
                    <i className="material-icons">arrow_forward</i>
                  </button>

                  <button
                    onClick={this.closeAllNotificationModal}
                    style={{ marginLeft: '5px' }}
                    className="btn waves-effect waves-light primary-btn col s12 m6 offset-m3 update-profile"
                    type="submit"
                    name="action"
                  >
                    No
                    <i className="material-icons">arrow_forward</i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Modal>

        <Modal
          isOpen={this.state.notificationModal}
          onRequestClose={this.closeNotificationModal}
          style={customStylesNotification}
          ariaHideApp={false}
          className="noti-modal"
        >
          <div className="modal-content addvehicle-content noti-poup">
          <div className="icon-preview addvehicle-cross">
              <a onClick={this.closeNotificationCross}>
                <i className="material-icons dp48">close</i>
              </a>
            </div>
            <NotificationTemplate
            notificationProps= {this.state.recievedNotifications}
            viewPopupId= {this.state.viewPopupId}
            />
          </div>
        </Modal>
        <div className="main-content bg-grey">
          <span>
            <div className="section-content dashboard">
              <div className="row">
                <div className="dashboard-tabs">
                  <div className="row ">
                    <div className="section-content">
                      <div className="row">
                        <div className="dashboard-bg settlement-dashboardbg d-head">
                          <BannerHead title="Notifications" />
                          
                        </div>
                        <div className="btn-control">
                              <div className={this.state.allChecked == true ? "all-checked-checkbox check-box-control" : "check-box-control"}>
                                {this.state.recievedNotifications.length > 0 ?                                 
                                <label>
                                <Checkbox checked={this.state.allChecked} onChange={this.CheckboxClick} value={1234}/>
                                Select ALL
                                </label> 
                                : ""}

                              </div>
                              <div className={this.state.allChecked == true ? "check-box-control" : "check-box-control-not-visible"}>
                              <div className="notification-icon">
                              <a
                                onClick={this.deleteAllConfirmNotificationModal}
                                >
                                <i className="material-icons dp48">
                                  delete
                                </i>
                                <span className="d-text-btn">
                                  Delete All
                                </span>
                              </a>
                              </div>
                              <div className={this.state.markAllStatus == true ? "notification-icon-disabled" : "notification-icon"}>
                              <a
                                onClick={this.state.markAllStatus == true ? (event) => event.preventDefault() : this.markAllReadConfirmModal}
                                >
                                <i className="material-icons dp48">
                                done_all
                                </i>
                                <span className="d-text-btn">
                                  Mark All Read
                                </span>
                              </a>
                              </div>
                              </div>
                          </div>
                        <div
                          id="AllSettlemnet"
                          className="col s12 tab-data  settlement-dbdata active"
                        >
                          {this.state.recievedNotifications && (
                            <ul className="list-noti">
                              {this.state.recievedNotifications
                                && this.state.recievedNotifications.map(
                                  notification => (
                                    
                                      <li className={notification.readStatus == 'Y' ? "col s12 noti-list-item" : "col s12 noti-list-item unread-list"}  key={notification.id} value={notification.notificationLogId} >
                                        <div className="col s12 m12 l12">
                                          <div className="notificationmain-box">
                                            <div className="notication-data">
                                              <div className="notication-data-list">
                                                <div className="noti-list-left">
                                                <div className="check-box">
                                                <label>
                                                  <Checkbox onChange={this.CheckboxClick} checked={notification.isChecked} id={notification.id} value={notification.id}/>
                                                </label>
                                                </div>
                                                <div className="notification-data" >
                                                <input
                                                  className="notification-dataInput"
                                                  type="text"
                                                  readOnly
                                                  name="recentAnswer"
                                                  id={notification.id}
                                                  value={notification.subject}
                                                  onClick={this.viewNotification}
                                                />
                                                  {/* <p >
                                                    {notification.subject}
                                                  </p> */}
                                                  <div>
                                                      {notification.targetURL !== '' ? (
                                                    <span>
                                                      {/* <a value={notification.notificationLogId} onClick={this.viewNotification}>click here to view</a> */}
                                                      {' '}
                                                    </span>
                                                  ) : '' }
                                                  </div>
                                                </div>
                                                </div>
                                                
                                                <div className="notification-date">
                                              <span>
                                              {moment(new moment.utc().format("MM/DD/YYYY")).diff(moment(moment.utc(notification.createdAt).format("MM/DD/YYYY")), 'HOUR') > 1
                                                ?
                                                moment.utc(
                                                  new Date(notification.createdAt),
                                                ).format('MMM DD')
                                                :
                                                (
                                                  moment(new moment.utc().format("HH:mm:ss"), 'HH:mm:ss').diff(moment(moment.utc(notification.createdAt).format("HH:mm:ss"), 'HH:mm:ss'), 'minutes') > 60 ||
                                                  Math.sign(moment(new moment.utc().format("HH:mm:ss"), 'HH:mm:ss').diff(moment(moment.utc(notification.createdAt).format("HH:mm:ss"), 'HH:mm:ss'), 'minutes')) == -1
                                                  ?
                                                moment(
                                                  notification.createdAt,
                                                ).format('LT')
                                                :
                                                moment(
                                                  notification.createdAt,
                                                ).fromNow()
                                                )
                                                }
                                              </span>
                                            </div>
                                                <div className="notification-icon">
                                                <a
                                                  href=""
                                                  onClick={e =>
                                                    this.deleteconfirmNotification(
                                                      e,
                                                      notification.id,
                                                    )
                                                  }
                                                >
                                                  <i className="material-icons dp48">
                                                    delete
                                                  </i>
                                                </a>
                                              </div>
                                              </div>

                                              
                                             
                                            </div>
                                            

                                          </div>
                                        </div>
                                      </li>
                                    
                                  ),
                                )}
                          {this.state.recievedNotifications.length < 1 && (
                            <span className="message"> No Notifications</span>
                          )}
                              <MuiThemeProvider>
                                <FlatPagination
                                  offset={this.state.offset}
                                  limit={10}
                                  total={
                                    recievedNotifications !== undefined
                                      ? (recievedNotifications.totalCount !== undefined) ? recievedNotifications.totalCount : 0
                                      : 0
                                  }
                                  onClick={(e, offset) =>
                                    this.getNotifications(offset)
                                  }
                                />
                              </MuiThemeProvider>
                            </ul>
                          )}

                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </span>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    markNotificationSuccess: state.data.markNotificationSuccess
  };
}



export default connect(mapStateToProps, null)(Notifications);
